export default __webpack_public_path__ + "static/media/fullscreen.1284df14.svg";